"use client"

import { CreditCard } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CreditCardIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CreditCardIcon = component(Icon)({ as: CreditCard })
